import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { RCS_MEDIA_CATEGORIES, RcsMedia } from 'src/app/models/Rcs';
import { RcsMediaService } from 'src/app/shared/services/rcs-media.service';

export const RCS_ALL_CATEGORIES = 'Todas';

/** Filtro da galeria por texto (título ou categoria, sem acento e sem caixa) e por categoria. */
export function filterMedia(items: RcsMedia[], search: string, category: string): RcsMedia[] {
  const fold = (value: string) => (value || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const query = fold(search).trim();

  return items.filter(item =>
    (category === RCS_ALL_CATEGORIES || item.category === category)
    && (!query || fold(item.title).includes(query) || fold(item.category).includes(query)));
}

/**
 * Escolha de imagem da galeria para o card RCS (molde `RCSImageGalleryModal` do
 * Misael). Fecha com a imagem escolhida; "Sem imagem" fecha com `null`.
 */
@Component({
  selector: 'app-rcs-gallery-modal',
  templateUrl: './rcs-gallery-modal.component.html',
})
export class RcsGalleryModalComponent implements OnInit {
  /** URL já escolhida, para marcar a imagem atual. */
  selectedUrl: string | null = null;

  readonly categories = [RCS_ALL_CATEGORIES, ...RCS_MEDIA_CATEGORIES];

  items: RcsMedia[] = [];
  loading = true;
  failed = false;
  search = '';
  category = RCS_ALL_CATEGORIES;
  showUpload = false;

  constructor(public activeModal: NgbActiveModal, private mediaService: RcsMediaService) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.failed = false;
    this.mediaService.list().subscribe({
      next: items => {
        this.items = items;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.failed = true;
      },
    });
  }

  get visible(): RcsMedia[] {
    return filterMedia(this.items, this.search, this.category);
  }

  choose(media: RcsMedia | null): void {
    this.activeModal.close(media);
  }

  onUploaded(media: RcsMedia): void {
    this.items = [media, ...this.items];
    this.showUpload = false;
    this.choose(media);
  }
}
